export default "__VITE_ASSET__6_o2iicY__"